import { ErrorHandler, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CommonApiService } from '../web-api-services/common.service';

@Injectable({
  providedIn: 'root',
})
export class CustomErrorHandlerService extends ErrorHandler {
  ignoredErrors: string[] = [];
  lastError: string = '';

  constructor(
    private commonApiService: CommonApiService,
    private router: Router,
  ) {
    super();
    this.ignoredErrors = [
      'NG0100', // ExpressionChangedAfterItHasBeenCheckedError,
      // RuntimeError@https://indicateurs.infoshn.fr/... throwErrorIfNoChangesMode
      'throwErrorIfNoChangesMode',
    ];
  }

  override handleError(error: any): void {
    if (error?.stack) {
      const errorString: string = `${error.stack.toString()}\n\rRoute : ${this.router?.url}\n\rUrl : ${window?.location?.toString()}`;
      const ignoreError = this.ignoredErrors.some(e => errorString.indexOf(e) > -1) || this.lastError == errorString;
      if (!ignoreError) {
        this.lastError = errorString;
        this.commonApiService.logClientError({ String: errorString }).subscribe();
      }
    }
    super.handleError(error);
  }
}
